<template>
  <th
    slot-scope="props"
    v-bind="props.thAttrs"
    v-on="props.thEvents"
  >
    <span
      class="VueTables__heading"
      :title="props.title"
    >
      {{ columnName }}
      <custom-sort-control
        :is-sortable="isSortable"
        :has-been-sorted="hasBeenSorted"
        :ascending="ascending"
      />
    </span>
  </th>
</template>

<script>
import { Event } from "vue-tables-2-premium";

import CustomSortControl from "./CustomSortControl";
export default {
    name: "VtTableHeading",
    components: {
        CustomSortControl
    },
    props: { props: { type: Object, required: true } },
    data() {
      return {
          columnName: "",
          isSortable: false,
          hasBeenSorted: false,
          ascending: false
      };
    },
    mounted() {
        this.columnName = this.props.heading.toLowerCase();
        this.isSortable = this.props.thAttrs.class.includes("sortable");

        Event.$on("vue-tables.sorted", (data) => {
            if (data.column === this.columnName) {
                this.hasBeenSorted = true;
                this.ascending = data.ascending;
            }
        });
    }
};
</script>

<style scoped lang="scss">
    .VueTables__heading {
        white-space: nowrap;
        text-transform: capitalize;
    }
</style>
